<template>
  <div class="stepper-range">
    <input
          v-model:value="count"
          type="number"
          pattern="\d*"
          :min="range.min"
          :max="range.max"
          @keyup="handleEvent"
          step="1">
    <button class="stepper-range__submit-button" @click="handleClick" :disabled="incorrectValue">
      <svg-icon width="16px" height="16px" :icon="Check"></svg-icon>
    </button>
  </div>

</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import Check from '@/assets/svg/Check.svg'
import { isDecimal } from '@/helpers'

export default {
  components: {
    SvgIcon
  },
  props: {
    attribute: Object
  },
  data () {
    return {
      Check,
      count: this.attribute.mustMatch ? this.attribute.mustMatch : 2,
      range: {
        min: 2,
        max: Math.round(this.attribute.children.length / 2) - 1
      }
    }
  },
  computed: {
    incorrectValue () {
      return this.count < this.range.min || this.count > this.range.max || isDecimal(this.count)
    }
  },
  methods: {
    handleClick () {
      this.$emit('select', this.count)
    },
    handleEvent (e) {
      // this is to prevent shortcuts from changing
      // definition while popover is open.
      e.stopPropagation()
    }
  }
}
</script>

<style lang="scss">

.stepper-range {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: auto;
  padding: 4px 8px;

  input {
    width: 80px;
    height: 30px;
    text-align: center;
    border-radius: 3px;
    border: 1px solid color(grays, dark);
    background: color(blue-grey, dark);
    color: white;
  }

  &__divider {
    padding: 10px;
  }

  &__submit-button {
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #A0A7AC;
    color: black;
    font-size: 16px;
    z-index: $z-4;

    &:hover {
      background-color: #27A500;
      cursor: pointer;
    }
    &:disabled {
      cursor: not-allowed;
      opacity: 0.4;

      &:hover {
        background-color: #A0A7AC;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// SingleStepperRange.vue?429b1f44